import { TimeRange, TimeRangeType } from 'data';

// Time range constants
export const TIME_RANGE = {
  TODAY: 'Today',
  WEEKLY: 'Last 7 days',
  MONTHLY: 'Last 30 days',
  YEARLY: 'Yearly'
} as const;

export const TIME_RANGE_TYPE = {
  DAYWISE: 'daywise',
  WEEKWISE: 'weekwise',
  MONTHWISE: 'monthwise'
} as const;

export const DEFAULT_RANGES = {
  WEEKLY_DAYS: 6,
  YEARLY_DAYS: 365,
  ACTIVE_DAYS: 60,
  ACTIVE_MONTHS: 6
} as const;

// utils.ts or constants.ts
export const getRangeTypeFromTimeRange = (range: TimeRange): TimeRangeType => {
  switch (range) {
    case TIME_RANGE.WEEKLY:
      return TIME_RANGE_TYPE.DAYWISE;
    case TIME_RANGE.MONTHLY:
      return TIME_RANGE_TYPE.WEEKWISE;
    case TIME_RANGE.YEARLY:
    default:
      return TIME_RANGE_TYPE.MONTHWISE;
  }
};

// Export constants
export { DEFAULT_RANGES as DefaultRanges };
